export const HelpCenterDependencyTypes = {
  HelpUrl: Symbol.for('HelpUrl'),
};
